import * as ventilstillingerActions from "../actions/ventilstillingerActions";

const INITIAL_STATE = {};

export default function miljoKontrollerBilderReducer(
  state = { ...INITIAL_STATE },
  action,
) {
  switch (action.type) {
    case ventilstillingerActions.GET_VENTILSTILLING_BILDER_SUCCESS:
      return {
        ...state,
        [action.payload.ventilstillingId]: action.payload.bilder,
      };
    default:
      return state;
  }
}
